module.exports = __webpack_public_path__ + "static/profile-michael-4262cc439cef53a49e42e6a44032575f.jpg";